import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class SeedFulfillmentViewEditBreakdownSliderModelService {
  public seedFulfillmentBreakdownSlider: BehaviorSubject<boolean>;
  public seedFulfillmentBreakdownSidenav: MatSidenav;
  private activeSliderValue: string;
  seedFulfillmentBreakdownSliderCloseRqt: Subject<boolean>;
  seedFulfillmentBreakdownModelData: BehaviorSubject<any>;
  seedFulfillmentProductData: BehaviorSubject<any> = new BehaviorSubject(EMPTY);
  public viewEditText: string;
  public releaseOrderItem: any;
  public branchPlant: string;
  public releaseItemsLots: any;

  constructor() {
    this.seedFulfillmentBreakdownSlider = new BehaviorSubject(false);
    this.seedFulfillmentBreakdownModelData = new BehaviorSubject(EMPTY);
    this.seedFulfillmentBreakdownSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'SeedFulfillmentBreakdown') {
      this.seedFulfillmentBreakdownSlider.next(true);
      this.seedFulfillmentBreakdownModelData.next(EMPTY);
      this.seedFulfillmentBreakdownSidenav.toggle();
    }
  }

  public setSeedFulfillmentBreakdownSideNav(seedFulfillmentBreakdownSideNavObj: MatSidenav) {
    this.seedFulfillmentBreakdownSidenav = seedFulfillmentBreakdownSideNavObj;
  }

  public seedFulfillmentBreakdownClose() {
    this.seedFulfillmentBreakdownModelData.next(EMPTY);
    this.seedFulfillmentBreakdownSlider.next(false);
    this.seedFulfillmentBreakdownSidenav.close();
  }

  public setSeedFulfillmentBreakDownData<T>(obj: T) {
    this.seedFulfillmentProductData.next(obj);
  }

  public setData<T>(obj: T) {
    this.seedFulfillmentBreakdownModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.seedFulfillmentBreakdownModelData.next(obj);
  }
}
